// extracted by mini-css-extract-plugin
export default {"Menu":"Menu_Menu__Niy9r","Menu_header":"Menu_Menu_header__4asux","Content":"Menu_Content__4c4qk","Footer":"Menu_Footer__GRLmj"};